
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/c",
      function () {
        return require("private-next-pages/c/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/c"])
      });
    }
  